const question8 = {
    'question': 'Ile trwa konsultacja seksuologiczna?',
    'answer': 'Czas przeznaczony na konsultację seksuologiczna w naszym Centrum w Toruniu to ok. 50 minut do godziny.'
}

export default question8;